/* custom-poster-configurator.js — v1.1.0 (2026-09-29) — testi: posterino/posterini
   Logica del configuratore poster personalizzati.
   - Prezzi e disponibilità letti dalle varianti (Modo × Dimensione × Cornice)
   - Validazione in capture-phase sul submit, poi lascia passare il form a Monster Cart Upsell
   - Fallback senza Monster: /cart/add.js + redirect al carrello
   - Barra sticky spostata su document.body per uscire dai container con transform */
(function () {
  'use strict';

  var root = document.querySelector('[data-cpc]');
  if (!root || root.dataset.cpcInit) return;
  root.dataset.cpcInit = '1';

  /* ---------- dati ---------- */
  var variants, cfg;
  try {
    variants = JSON.parse(root.querySelector('[data-cpc-variants]').textContent);
    cfg = JSON.parse(root.querySelector('[data-cpc-config]').textContent);
  } catch (e) { console.error('cpc: dati non validi', e); return; }

  var names = (cfg.optionNames || []).map(function (n) { return String(n).toLowerCase(); });
  var iMode = idx(['modo', 'mode']), iFmt = idx(['dimensione', 'formato', 'size']), iFrame = idx(['cornice', 'frame']);
  function idx(cands) { for (var i = 0; i < names.length; i++) { if (cands.indexOf(names[i]) > -1) return i; } return -1; }
  if (iMode < 0 || iFmt < 0 || iFrame < 0) { console.error('cpc: opzioni prodotto attese Modo / Dimensione / Cornice, trovate:', cfg.optionNames); }

  var MODE_VAL = { A: String(cfg.modeA).toLowerCase(), B: String(cfg.modeB).toLowerCase() };
  var MODE_LABEL = { A: cfg.modeA, B: cfg.modeB };
  var FORMATS = cfg.formats, FRAMES = cfg.frames, NONE = FRAMES[0];
  var FMT_LABEL = { '21x30cm': '21×30 cm', '30x40cm': '30×40 cm', '50x70cm': '50×70 cm' };
  var FRAME_LABEL = { 'senza cornice': 'Senza cornice', 'cornice nera': 'Cornice nera', 'cornice legno': 'Cornice in legno' };
  var FRAME_CLASS = { 'senza cornice': 'f-none', 'cornice nera': 'f-nera', 'cornice legno': 'f-legno' };
  var PW = { '21x30cm': '44%', '30x40cm': '58%', '50x70cm': '80%' };
  var PAR = { '21x30cm': '21/30', '30x40cm': '30/40', '50x70cm': '50/70' };
  var PHRASE_MAX = parseInt(root.dataset.phraseMax, 10) || 60;
  var INITIAL_TILES = 9;

  var byKey = {};
  variants.forEach(function (v) {
    var o = [v.o1, v.o2, v.o3];
    byKey[[o[iMode], o[iFmt], o[iFrame]].join('|')] = v;
  });
  function variantFor(mode, fmt, frame) { return byKey[[MODE_VAL[mode], fmt, frame].join('|')] || null; }
  function basePrice(mode, fmt) { var v = variantFor(mode, fmt, NONE); return v ? v.price : null; }
  function frameDelta(mode, fmt, frame) { var v = variantFor(mode, fmt, frame), b = basePrice(mode, fmt); return (v && b != null) ? v.price - b : null; }

  /* ---------- money ---------- */
  function money(cents, short) {
    var fmt = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = (cents / 100);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var dec = /no_decimals/.test(key) ? 0 : 2;
    var thou = ',', point = '.';
    if (/comma_separator/.test(key)) { thou = '.'; point = ','; }
    else if (/space_separator/.test(key)) { thou = ' '; point = ','; }
    else if (/apostrophe_separator/.test(key)) { thou = "'"; point = '.'; }
    var s = n.toFixed(dec);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out = parts.length > 1 ? parts[0] + point + parts[1] : parts[0];
    if (short && dec === 2 && /00$/.test(parts[1])) out = parts[0];
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }

  /* ---------- stato ---------- */
  var state = { mode: 'A', design: null, designTitle: '', designImg: '', phrase: '', note: '', brief: '', ref: '', format: '30x40cm', frame: NONE, pickerOpen: true, showAll: false, query: '' };

  /* ---------- riferimenti DOM ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  var form = $('[data-cpc-form]');
  var tiles = $$('[data-cpc-design]');
  var sticky = $('[data-cpc-sticky]');

  // barra sticky fuori dai container con transform (pattern del tema): da qui in poi va cercata dentro `sticky`, non in root
  if (sticky && sticky.parentElement !== document.body) document.body.appendChild(sticky);
  var stickyPrice = sticky ? sticky.querySelector('[data-cpc-sticky-price]') : null;
  var stickySub = sticky ? sticky.querySelector('[data-cpc-sticky-sub]') : null;

  /* ---------- render ---------- */
  function render() {
    var d = state.design;
    var v = variantFor(state.mode, state.format, state.frame);
    var base = basePrice(state.mode, state.format);
    var delta = frameDelta(state.mode, state.format, state.frame) || 0;
    var total = v ? v.price : (base || 0);

    // modo
    $$('[data-cpc-mode]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.cpcMode === state.mode); });
    $$('[data-cpc-flow]').forEach(function (f) { f.hidden = f.dataset.cpcFlow !== state.mode; });
    $('[data-cpc-num="format"]').textContent = (state.mode === 'A' ? '4' : '3') + ' · Il formato';
    $('[data-cpc-num="frame"]').textContent = (state.mode === 'A' ? '5' : '4') + ' · La cornice';
    ['A', 'B'].forEach(function (m) {
      var min = null;
      FORMATS.forEach(function (f) { var p = basePrice(m, f); if (p != null && (min == null || p < min)) min = p; });
      var el = $('[data-cpc-from="' + m + '"]'); if (el) el.textContent = min != null ? money(min, true) : '—';
    });

    // picker
    var collapsed = !!d && !state.pickerOpen;
    $('[data-cpc-selected]').hidden = !collapsed;
    $('[data-cpc-picker]').hidden = collapsed;
    if (collapsed) {
      $('[data-cpc-selected-title]').textContent = state.designTitle;
      var si = $('[data-cpc-selected-img]'); si.src = state.designImg; si.alt = state.designTitle;
    }
    var q = state.query.trim().toLowerCase(), matches = 0;
    tiles.forEach(function (t, i) {
      var match = !q || (t.dataset.search || '').indexOf(q) > -1;
      if (match) matches++;
      t.hidden = !(match && (q || state.showAll || i < INITIAL_TILES));
      t.setAttribute('aria-checked', state.design === t.dataset.cpcDesign);
    });
    $('[data-cpc-empty]').hidden = matches > 0;
    var more = $('[data-cpc-more]');
    more.hidden = !!q || matches <= INITIAL_TILES;
    more.textContent = state.showAll ? 'Mostra meno' : 'Mostra tutti i ' + tiles.length + ' posterini';

    // formato
    $$('[data-cpc-format]').forEach(function (b) {
      var f = b.dataset.cpcFormat, p = basePrice(state.mode, f);
      b.setAttribute('aria-checked', state.format === f);
      b.disabled = p == null;
      var pr = $('[data-cpc-price-for="' + f + '"]'); if (pr) pr.textContent = p != null ? money(p, true) : 'n.d.';
    });

    // cornice
    $$('[data-cpc-frame]').forEach(function (b) {
      var fr = b.dataset.cpcFrame, ok = !!variantFor(state.mode, state.format, fr);
      b.disabled = !ok;
      b.setAttribute('aria-checked', state.frame === fr);
      var pr = $('[data-cpc-frame-price="' + fr + '"]');
      if (pr && fr !== NONE) { var dl = frameDelta(state.mode, state.format, fr); pr.textContent = dl != null ? '+' + money(dl, true) : 'non disponibile'; }
    });
    $('[data-cpc-frame-notice]').hidden = !!variantFor(state.mode, state.format, FRAMES[1]);

    // contatori
    $('[data-cpc-phrase-count]').textContent = state.phrase.length;
    $('[data-cpc-brief-count]').textContent = state.brief.length;

    // sticky
    if (stickyPrice) stickyPrice.textContent = money(total, true);
    var parts = [MODE_LABEL[state.mode]];
    if (state.mode === 'A') parts.push(d ? state.designTitle : 'scegli un posterino');
    parts.push(FMT_LABEL[state.format].replace(' cm', ''));
    if (state.frame !== NONE) parts.push(FRAME_LABEL[state.frame].toLowerCase());
    if (stickySub) stickySub.textContent = parts.join(' · ');

    // riepilogo
    var framed = $('[data-cpc-framed]');
    framed.className = 'cpc-framed ' + FRAME_CLASS[state.frame];
    framed.style.setProperty('--cpc-pw', PW[state.format]);
    framed.style.setProperty('--cpc-par', PAR[state.format]);
    var pimg = $('[data-cpc-preview-img]'), ghost = $('[data-cpc-ghost]');
    if (state.mode === 'A' && d) { pimg.src = state.designImg; pimg.alt = state.designTitle; pimg.hidden = false; ghost.hidden = true; }
    else { pimg.hidden = true; ghost.hidden = false; $('[data-cpc-ghost-text]').textContent = state.mode === 'A' ? 'Scegli un posterino' : 'La tua grafica, disegnata da zero'; }
    var rows = [['Modo', MODE_LABEL[state.mode]]];
    if (state.mode === 'A') {
      rows.push(['Posterino', d ? state.designTitle : '—']);
      rows.push(['La tua frase', state.phrase.trim() ? '«' + state.phrase.trim() + '»' : '—']);
      if (state.note.trim()) rows.push(['Nota', state.note.trim()]);
    } else {
      var b = state.brief.trim();
      rows.push(['Indicazioni', b ? (b.length > 90 ? b.slice(0, 90) + '…' : b) : '—']);
      rows.push(['Riferimento', state.ref.trim() || '—']);
    }
    rows.push(['Formato', FMT_LABEL[state.format]]);
    rows.push(['Cornice', FRAME_LABEL[state.frame]]);
    $('[data-cpc-sum-list]').innerHTML = rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    var ph = '<div><span>Poster ' + FMT_LABEL[state.format].replace(' cm', '') + '</span><span>' + money(base || 0) + '</span></div>';
    if (delta) ph += '<div><span>' + FRAME_LABEL[state.frame] + '</span><span>+' + money(delta) + '</span></div>';
    ph += '<div class="tot"><span>Totale</span><span>' + money(total) + '</span></div>';
    $('[data-cpc-sum-price]').innerHTML = ph;

    syncForm(v);
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- form nascosto ---------- */
  function setProp(name, value, enabled) {
    var el = $('[data-cpc-prop="' + name + '"]'); if (!el) return;
    el.value = value || ''; el.disabled = !enabled || !value;
  }
  function syncForm(v) {
    $('[data-cpc-variant-id]').value = v ? v.id : '';
    setProp('modo', MODE_LABEL[state.mode], true);
    var A = state.mode === 'A';
    setProp('design', A ? state.designTitle : '', A);
    setProp('design_handle', A ? state.design : '', A);
    setProp('frase', A ? state.phrase.trim() : '', A);
    setProp('nota', A ? state.note.trim() : '', A);
    setProp('brief', !A ? state.brief.trim() : '', !A);
    setProp('ref', !A ? state.ref.trim() : '', !A);
  }

  /* ---------- validazione ---------- */
  function showErr(el, on) { if (!el) return; if (el.matches('[data-cpc-field]')) el.classList.toggle('is-error', on); var e = el.matches('.cpc-err') ? el : el.querySelector('.cpc-err'); if (e) e.hidden = !on; }
  function validate() {
    var ok = true, first = null;
    if (state.mode === 'A') {
      var eD = $('[data-cpc-err="design"]');
      if (!state.design) { showErr(eD, true); ok = false; first = first || $('[data-cpc-step="design"]'); } else showErr(eD, false);
      var pf = $('[data-cpc-field="phrase"]');
      if (!state.phrase.trim()) { showErr(pf, true); ok = false; first = first || pf; } else showErr(pf, false);
    } else {
      var bf = $('[data-cpc-field="brief"]');
      if (state.brief.trim().length < 20) { showErr(bf, true); ok = false; first = first || bf; } else showErr(bf, false);
    }
    if (!variantFor(state.mode, state.format, state.frame)) { ok = false; first = first || $('[data-cpc-step="frame"]'); }
    if (!ok && first) scrollTo(first);
    return ok;
  }
  function scrollTo(el) { try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); } }

  /* ---------- submit ---------- */
  // capture-phase: gira prima di qualsiasi listener del form (Monster incluso)
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    render();
    if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var ctas = $$('[data-cpc-cta]', document); ctas.forEach(function (b) { b.disabled = true; });
    setTimeout(function () { ctas.forEach(function (b) { b.disabled = false; }); }, 4000);
    var monster = typeof window.monster_submitAddToCartForm === 'function' || typeof window.handleAddToCart === 'function';
    if (monster && !window.upsellCartStopped) return; // Monster intercetta il submit e apre il suo drawer
    // fallback: AJAX + drawer Dawn se presente, altrimenti pagina carrello
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(form);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    fetch(cfg.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'Errore'); return; }
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else { window.location.href = cfg.cartUrl; }
      })
      .catch(function () { window.location.href = cfg.cartUrl; });
  }, true);

  /* ---------- eventi ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.cpcMode) { state.mode = t.dataset.cpcMode; render(); return; }
    if (t.dataset.cpcDesign) {
      state.design = t.dataset.cpcDesign; state.designTitle = t.dataset.title; state.designImg = t.dataset.img; state.pickerOpen = false;
      render(); var ph = $('[data-cpc-step="phrase"]'); scrollTo(ph); try { $('[data-cpc-phrase]').focus({ preventScroll: true }); } catch (x) {}
      return;
    }
    if (t.hasAttribute('data-cpc-change-design')) { state.pickerOpen = true; render(); scrollTo($('[data-cpc-step="design"]')); return; }
    if (t.hasAttribute('data-cpc-more')) { state.showAll = !state.showAll; render(); return; }
    if (t.dataset.cpcFormat && !t.disabled) { state.format = t.dataset.cpcFormat; if (!variantFor(state.mode, state.format, state.frame)) state.frame = NONE; render(); return; }
    if (t.dataset.cpcFrame && !t.disabled) { state.frame = t.dataset.cpcFrame; render(); return; }
    if (t.hasAttribute('data-cpc-note-toggle')) {
      var nf = $('[data-cpc-note-field]'); nf.hidden = !nf.hidden;
      t.textContent = nf.hidden ? '+ Aggiungi una nota per noi (opzionale)' : '− Togli la nota';
      if (!nf.hidden) try { $('[data-cpc-note]').focus({ preventScroll: true }); } catch (x) {}
      return;
    }
    if (t.dataset.cpcSnippet) {
      var ta = $('[data-cpc-brief]'); var v = ta.value;
      ta.value = v + (v && !/\n$/.test(v) ? '\n' : '') + t.dataset.cpcSnippet; state.brief = ta.value; ta.focus(); render(); return;
    }
  });

  $('[data-cpc-search]').addEventListener('input', function (e) { state.query = e.target.value; render(); });
  $('[data-cpc-phrase]').addEventListener('input', function (e) { state.phrase = e.target.value.slice(0, PHRASE_MAX); if (state.phrase.trim()) showErr($('[data-cpc-field="phrase"]'), false); render(); });
  $('[data-cpc-note]').addEventListener('input', function (e) { state.note = e.target.value; render(); });
  $('[data-cpc-brief]').addEventListener('input', function (e) { state.brief = e.target.value; if (state.brief.trim().length >= 20) showErr($('[data-cpc-field="brief"]'), false); render(); });
  $('[data-cpc-ref]').addEventListener('input', function (e) { state.ref = e.target.value; render(); });

  // sicurezza sul formato preselezionato: se non esiste nel prodotto, prendi il primo disponibile
  if (basePrice(state.mode, state.format) == null) {
    for (var i = 0; i < FORMATS.length; i++) { if (basePrice(state.mode, FORMATS[i]) != null) { state.format = FORMATS[i]; break; } }
  }

  /* ---------- preselezione da ?design= ---------- */
  var params = new URLSearchParams(window.location.search);
  var pre = params.get('design');
  if (pre) {
    var tile = tiles.filter(function (t) { return t.dataset.cpcDesign === pre; })[0];
    if (tile) {
      state.mode = 'A'; state.design = pre; state.designTitle = tile.dataset.title; state.designImg = tile.dataset.img; state.pickerOpen = false;
      var banner = $('[data-cpc-pdp-banner]'); banner.hidden = false; $('[data-cpc-pdp-title]').textContent = tile.dataset.title;
      render();
      setTimeout(function () { scrollTo($('[data-cpc-step="design"]')); }, 300);
    } else render();
  } else render();
})();
